module.exports = __webpack_public_path__ + "static/media/1.4da24c9c.png";